
import React from "react";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { ITeamMember } from "../../../../../services";
import styles from "../../assets/style.module.css";

export function memberRole(m: ITeamMember): { key: string; label: string; } {
    const labels = i18nManager.Labels.members;
    if (m.role === "OWNER") return { key: "owner", label: labels.owner };
    if (m.role === "MODERATOR") return { key: "moderator", label: labels.moderator };
    if (m.status === "PAST") return { key: "former", label: labels.former_badge };
    return { key: "member", label: labels.member };
}

export interface MemberCardProps {
    member: ITeamMember;
    onSelect: (m: ITeamMember) => void;
}

function MemberCard({ member: m, onSelect }: MemberCardProps) {

    const role = memberRole(m);

    return (<button className={styles["member-card"]} onClick={() => onSelect(m)}>
        <div className={styles["member-card-media"]}>
            <img className={styles["member-card-img"]} src={m.half_body_picture_url || m.passport_picture_url} alt={m.display_name} loading="lazy" />
            <div className={styles["member-card-shade"]} />
        </div>
        <div className={styles["member-card-body"]}>
            <span className={Classname.build(styles["role-pill"], styles[`role-${role.key}`])}>{role.label}</span>
            <span className={styles["member-card-name"]}>{m.display_name}</span>
            {m.settings?.country && (<span className={styles["member-card-country"]}>{m.settings.country}</span>)}
        </div>
    </button>);
}

export default MemberCard;
